import { useEffect, useState } from "react";
import { MemberTable } from "./MemberTable/MemberTable";
import { DASHBOARD_MODALS } from "../Dashboard";
import AddMemberModal from "../AddMemberModal/AddMemberModal";
import { getNpInfo } from "../../../api/NonprofitInfo";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export default function MemberList() {
  const [localUserData, setLocalUserData] = useState(null);
  const [memberData, setMemberData] = useState(null);
  const [modal, setModal] = useState("");
  const userData = useSelector((state) => state.userData.userData);

  const getMemberList = async () => {
    try {
      const response = await getNpInfo(localUserData.nonprofit);
      if (response) {
        setMemberData(response.members);
      }
    } catch (error) {
      console.error("Error getting Members: ", error);
    }
  };

  const hideModals = () => setModal("");

  useEffect(() => {
    if (Object.keys(userData).length !== 0) {
      setLocalUserData(JSON.parse(userData));
    }
  }, [userData]);

  useEffect(() => {
    if (localUserData) {
      getMemberList();
    }
  }, [localUserData]);

  return (
    <>
      <div className="flex-1 bg-gray-100 min-h-screen p-8">
        {/* Header */}
        <div className="flex items-start justify-between mb-2">
          <div>
            <h1 className="!text-[30px] !font-bold !font-poppins text-blue-navy text-left">Team Members</h1>
            <p className="!text-sm text-gray-500 mt-1 text-left">View all your team members by first name, last name, access level, and action.</p>
          </div>
          {localUserData?.np_access_level === "admin" && (
            <button
              onClick={() => setModal(DASHBOARD_MODALS.addMember)}
              className="flex items-center gap-2 bg-blue text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:opacity-90 whitespace-nowrap"
            >
              <FontAwesomeIcon icon={faPlus} size="sm" />
              Add Team Member
            </button>
          )}
        </div>

        {/* Table card */}
        <div className="bg-white rounded-2xl shadow-md mt-6 overflow-hidden">
          {memberData ? (
            <MemberTable data={memberData} setModal={setModal} localUserData={localUserData} />
          ) : (
            <div className="p-8 text-center text-gray-400 text-sm">Loading team members...</div>
          )}
        </div>
      </div>

      {modal === DASHBOARD_MODALS.addMember && <AddMemberModal close={hideModals} />}
    </>
  );
}
